import { getElementById } from "../util/Utils";
import { any } from "../util/Reductions";

const ToggleNames = [
  "DUMMY",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL_EXPERIMENT",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL_TRACKING",
  "HEUREKA_2047_NEXT_BEST_FACET",
  "HEUREKA_2047_NEXT_BEST_FACET_E3792",
  "HEUREKA_2167_MIGRATE_FILTER_BANNER_TO_SVELTE",
  "HEUREKA_2167_MIGRATE_DESKTOP_SORTING_TO_SVELTE",
  "HEUREKA_2167_MIGRATE_FILTERS_TO_SVELTE",
  "HEUREKA_2178_FILTER_SECTION_IS_NOT_LOADED",
  "HEUREKA_2276_STATELESS_TRACKING_CHANGE",
  "HEUREKA_2276_STATELESS_TRACKING_SUBMIT",
  "HEUREKA_2320_NO_HORIZONTAL_SCROLLING_FOR_DIMENSION_FACETS",
  "HEUREKA_2321_FILTERBAR_V2",
  "HEUREKA_2321_FILTERBAR_V2_E3911",
  "HEUREKA_2388_FIX_EMPTY_DETAILSHEET_AFTER_BROWSER_BACK",
  "HEUREKA_2381_DONT_RETRIEVE_ENTRYRULE_FROM_HISTORY",
  "HEUREKA_2395_REMOVE_LOCAL_NAVIGATION_ON_TOPIC_PAGES",
  "HEUREKA_2398_OPTIMIZE_FILTER_SHEET_PERFORMANCE",
  "HEUREKA_2398_LOAD_NOT_SHOWN_VALUES_ASYNCHRONOUSLY",
  "HEUREKA_2398_ALL_LEVEL_SHEET",
  "HEUREKA_2403_ALWAYS_THROW_NEXT_BEST_ACTION_LOADED",
  "HEUREKA_2404_FIX_WRONG_SORTING_SIZE_VALUES",
  "HEUREKA_2398_HC_SHEET",
  "HEUREKA_2407_MIGRATE_TO_REPTILE_NEXUS",
  "HEUREKA_2349_BATCH_DRESONRULE_ON_MOBILE",
  "HEUREKA_2437_FIX_LOCK_ALL",
  "HEUREKA_2444_DONT_SCROLL_AFTER_FILTER_SUBMIT",
] as const;

export type ToggleName = (typeof ToggleNames)[number];
export type ToggleStates = Record<ToggleName, boolean>;

let toggles: ToggleStates;

function asBoolean(value?: string): boolean {
  return "true" === value;
}

export function initToggles() {
  const data = getElementById("leafcutter_toggles")?.dataset;
  const state = data
    ? (toggleName: ToggleName) => asBoolean(data[toggleName] || data[toggleName.toLowerCase()])
    : () => false;
  toggles = ToggleNames.reduce((htmlToggles, toggleName) => {
    htmlToggles[toggleName] = state(toggleName);
    return htmlToggles;
  }, {} as Partial<ToggleStates>) as ToggleStates;
}

/**
 *
 */
export function updateToggle(toggle: ToggleName, state: boolean) {
  if (!toggles) {
    toggles = {} as ToggleStates;
  }
  toggles[toggle] = state;
}

export function isActive(toggle: ToggleName) {
  return toggles[toggle];
}

export function isNotActive(toggle: ToggleName) {
  return !isActive(toggle);
}

export function isAnyActive(...toggles: ToggleName[]) {
  return toggles.map(isActive).reduce(any, false);
}
